export const dateLocalToUTC = (val: Date): Date => {
  var now = new Date(val);
  return new Date(now.getTime() + now.getTimezoneOffset() * 60000);
};
